import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {FormBuilder, FormGroup, FormControl, Validators, AbstractControl} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {AutenticacaoApiService} from '../../../service/api/autenticacao.api';
import {environment} from '../../../environments/environment';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';
import {
    FTA,
    Cliente,
    OrigemTransmissao,
    DestinoTransmissao,
    InstalacaoProduto,
    ServicoVinculado,
    EventoOperacao,
    OrigemTransmissaoMigracao,
    DestinoTransmissaoMigracao,
    Servico,
    Operacao
} from '../../../model/catalogo';
import {Observable, TimeoutError} from 'rxjs/Rx';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/observable/interval';
import 'rxjs/add/observable/of';
import {map, concatMap, delay, catchError, take} from 'rxjs/operators';

@Component({
    selector: 'app-migracao-fta-modal',
    templateUrl: './migracao-fta-modal.component.html',
    styleUrls: ['./migracao-fta-modal.component.css']
})
export class MigracaoFtaModalComponent implements OnInit {

    constructor(
        public globalService: GlobalService,
        public modalService: ModalService,
        public pesquisaService: PesquisasFiltroApiService,
        public detalhamentoService: DetalhamentoApiService,
        public catalogoApi: CatalogoApiService,
        private formBuilder: FormBuilder,
        public autenticacaoApiService: AutenticacaoApiService,
        private route: ActivatedRoute) {
    }

    sub: any;
    codFTA: number;
    vrsFTA: number;
    ftaOrigem: FTA;
    ambienteOrigem: any;
    ambienteDestino: any;
    tokenOrigem: any;
    tokenDestino: any = '';
    isAutenticadoNoDestino: boolean = false;
    mensagens: string;
    submitted: boolean = false;

    origem: Array<OrigemTransmissao> = new Array<OrigemTransmissao>();
    destino: Array<DestinoTransmissao> = new Array<DestinoTransmissao>();
    dadosOrigem: Array<OrigemTransmissaoMigracao> = new Array<OrigemTransmissaoMigracao>();
    dadosDestino: Array<DestinoTransmissaoMigracao> = new Array<DestinoTransmissaoMigracao>();
    dadosServico: Array<ServicoVinculado> = new Array<ServicoVinculado>();
    dadosOperacao: Array<EventoOperacao> = new Array<EventoOperacao>();

    dadosMigracaoOrigem: Array<OrigemTransmissaoMigracao> = new Array<OrigemTransmissaoMigracao>();
    dadosMigracaoDestino: Array<DestinoTransmissaoMigracao> = new Array<DestinoTransmissaoMigracao>();
    dadosMigracaoServico: Array<ServicoVinculado> = new Array<ServicoVinculado>();
    dadosMigracaoOperacao: Array<EventoOperacao> = new Array<EventoOperacao>();

    campoAmbiente = new FormControl('0', [ValidaCampoAmbiente]);
    opcoesAmbiente: Array<any> = new Array<any>();
    campoUsuario = new FormControl('', [Validators.required]);
    campoSenha = new FormControl('', [Validators.required]);

    migracaoModalForm: FormGroup = this.formBuilder.group({
        campoAmbiente: this.campoAmbiente,
        campoUsuario: this.campoUsuario,
        campoSenhaha: this.campoSenha
    });

    ngOnInit() {

        sessionStorage.setItem('isModalMigracaoOpen', 'true');
        this.mensagens = '';

        this.sub = this.route.queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['codFTA'] != '') {
                    this.codFTA = params['codFTA'];
                }
                if (params['vrsFTA'] != '') {
                    this.vrsFTA = params['vrsFTA'];
                }
            });

        switch (this.globalService.configuracao.ambiente) {
            case 'Desenvolvimento':
                this.opcoesAmbiente.push({'valor': 'HMG', 'nome': 'Homologação'});
                this.opcoesAmbiente.push({'valor': 'PRD', 'nome': 'Produção'});
                break;
            case 'Homologação':
                this.opcoesAmbiente.push({'valor': 'DES', 'nome': 'Desenvolvimento'});
                this.opcoesAmbiente.push({'valor': 'PRD', 'nome': 'Produção'});
                break;
            case 'Produção':
                this.opcoesAmbiente.push({'valor': 'DES', 'nome': 'Desenvolvimento'});
                this.opcoesAmbiente.push({'valor': 'HMG', 'nome': 'Homologação'});
                break;
            case 'LocalDes':
                this.opcoesAmbiente.push({'valor': 'HMG', 'nome': 'Homologação'});
                this.opcoesAmbiente.push({'valor': 'PRD', 'nome': 'Produção'});
                break;
            case 'LocalHm':
                this.opcoesAmbiente.push({'valor': 'DES', 'nome': 'Desenvolvimento'});
                this.opcoesAmbiente.push({'valor': 'PRD', 'nome': 'Produção'});
                break;
            case 'LocalPrd':
                this.opcoesAmbiente.push({'valor': 'DES', 'nome': 'Desenvolvimento'});
                this.opcoesAmbiente.push({'valor': 'HMG', 'nome': 'Homologação'});
                break;
        }

        //obtem dados completos do fta de origem
        this.recuperaFtaOrigem();

    }

    getTokenDestino() {
        this.mensagens = '';
        this.submitted = true;

        if (this.migracaoModalForm.valid) {

            this.autenticacaoApiService.loginUsuario(this.campoUsuario.value, this.campoSenha.value, environment.api_escopo, null, this.campoAmbiente.value)
                .subscribe(
                    (usuario) => {
                        this.globalService.loading = false;
                        this.tokenDestino = usuario.access_token;
                        this.isAutenticadoNoDestino = true;
                        this.ajustarFta();
                    },
                    (erro: any) => {
                        this.isAutenticadoNoDestino = false;
                        console.error('Erro autenticação');
                        var erroJson;
                        erroJson = <any>erro;
                        if (erro.status == 400) {
                            if (erroJson) {
                                this.mensagens = erroJson.error_description;
                            }
                        } else if (erro.status == 401) {
                            this.mensagens = 'Usuário inválido ou senha incorreta.';
                        } else if (erro.status == 403) {
                            this.mensagens = 'Solicitar ACESSO-11-01 Aplicativo GMT';
                        } else if (erro.status == 404) {
                            this.mensagens = 'Servidor não respondendo';
                        } else if (erro.status == 500) {
                            if (erroJson) {
                                this.mensagens = erroJson.error_description;
                            }
                        } else if (erro instanceof TimeoutError) {
                            this.mensagens = 'Falha no login';
                        } else {
                            this.mensagens = 'Falha no login';
                        }

                    },
                    () => console.log('Autenticação realizada')
                );
        } else {
            this.mensagens = 'Preencha todos os campos';
        }
    }

    limparAmbienteDestino() {
        this.isAutenticadoNoDestino = false;
        this.tokenDestino = '';
    }

    recuperaFtaOrigem() {
        this.detalhamentoService.detalhaFta(this.codFTA, this.vrsFTA)
            .subscribe(resposta => {
                    this.ftaOrigem = resposta as FTA;
                },
                erro => {
                    this.globalService.loading = false;
                    this.mensagens = `Erro ao recuperar detalhes do FTA de origem.`;
                    return false;
                });
    }

    buscarClientes(tipo: string): Observable<Array<any>> {
        let user: any;
        let usuariosComId = [];
        let observablesUsuarios: any = [];

        if (tipo == 'origem') {
            this.dadosOrigem.forEach(element => {
                let userAplicacao = null;
                let mci = null;
                let uor = null;
                if (element.clienteOrigem.codTipoCliente == 1) {
                    userAplicacao = {'nomeUserAplicacao': element.clienteOrigem.userAplicacao.nomeUserAplicacao};
                }
                if (element.clienteOrigem.codTipoCliente == 2) {
                    mci = {'codMci': element.clienteOrigem.mci.codMci.toString()};
                }
                if (element.clienteOrigem.codTipoCliente == 3) {
                    uor = {'codUor': element.clienteOrigem.uor.codUor.toString()};
                }
                let filtros: Array<any> = new Array<any>();
                filtros.push({
                    'filtroCliente': {
                        'codTipoCliente': element.clienteOrigem.codTipoCliente,
                        'userAplicacao': userAplicacao,
                        'mci': mci,
                        'uor': uor
                    }
                });
                observablesUsuarios.push(this.pesquisaService.filtraCliente(filtros));
            });
        } else {
            this.dadosDestino.forEach(element => {
                let userAplicacao = null;
                let mci = null;
                let uor = null;
                if (element.clienteDestino.codTipoCliente == 1) {
                    userAplicacao = {'nomeUserAplicacao': element.clienteDestino.userAplicacao.nomeUserAplicacao};
                }
                if (element.clienteDestino.codTipoCliente == 2) {
                    mci = {'codMci': element.clienteDestino.mci.codMci.toString()};
                }
                if (element.clienteDestino.codTipoCliente == 3) {
                    uor = {'codUor': element.clienteDestino.uor.codUor.toString()};
                }
                let filtros: Array<any> = new Array<any>();
                filtros.push({
                    'filtroCliente': {
                        'codTipoCliente': element.clienteDestino.codTipoCliente,
                        'userAplicacao': userAplicacao,
                        'mci': mci,
                        'uor': uor
                    }
                });
                observablesUsuarios.push(this.pesquisaService.filtraCliente(filtros));
            });
        }

        //envia todas as requisicoes para usuarios compativeis com o ambiente de destino.
        if (observablesUsuarios.length > 0) {
            return Observable.forkJoin(observablesUsuarios);
        } else {
            return Observable.of(null);
        }
    }

    buscarInstalacoes(tipo: any): Observable<Array<any>> {

        let observables: any = [];

        if (tipo == 'origem') {
            this.dadosOrigem.forEach(element => {
                let instalacao = element.nomeInstalacaoProdutoOrigem;
                let filtros: Array<any> = new Array<any>();
                filtros.push({'filtroInstalacaoProduto': {'nomeInstalacao': instalacao}});
                observables.push(this.pesquisaService.filtraInstalacaoProduto(filtros));
            });
        } else {
            this.dadosDestino.forEach(element => {
                let instalacao = element.nomeInstalacaoProdutoDestino;
                let filtros: Array<any> = new Array<any>();
                filtros.push({'filtroInstalacaoProduto': {'nomeInstalacao': instalacao}});
                observables.push(this.pesquisaService.filtraInstalacaoProduto(filtros));
            });
        }

        //envia todas as requisicoes para usuarios compativeis com o ambiente de destino.
        if (observables.length > 0) {
            return Observable.forkJoin(observables);
        } else {
            return Observable.of(null);
        }

    }

    buscarServicos(servicos: Array<ServicoVinculado>): Observable<Array<any>> {
        let user: any;
        let usuariosComId = [];
        let observablesServicos: Array<Observable<Array<ServicoVinculado>>> = [];


        //remove duplicados
        let servicosAux = servicos.filter(function (a) {
            return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
        }, Object.create(null));


        servicosAux.forEach(element => {
            let filtros = {'filtroServico': {'nome': element.nome}};
            observablesServicos.push(this.pesquisaService.filtraServico(filtros));
        });
        //envia todas as requisicoes para verificar servicos compativeis com o ambiente de destino.
        if (observablesServicos.length > 0) {
            return Observable.forkJoin(observablesServicos);
        } else {
            return Observable.of(null);
        }
    }

    ajustarFta() {

        this.ftaOrigem.fta = 0;
        this.ftaOrigem.versao = 0;

        this.ftaOrigem.eventos.forEach((evento, indexEvt) => {

            this.origem = [];
            if (evento.detalheEventoTransmissao != null) {

                //remove layout
                delete evento.detalheEventoTransmissao.codLayout;
                delete evento.detalheEventoTransmissao.vrsLayout;
                delete evento.detalheEventoTransmissao.nomeLayout;

                //ajusta origem
                evento.detalheEventoTransmissao.origem.forEach(origemTransmissao => {
                    origemTransmissao.codInstalacaoProdutoOrigem = null;
                    origemTransmissao.vrsInstalacaoProdutoOrigem = null;
                    if (origemTransmissao.clienteOrigem.codTipoCliente == 1) {
                        origemTransmissao.clienteOrigem.userAplicacao.codUserAplicacao = null;
                    }
                    this.origem.push(origemTransmissao);
                    let origemTransmissaoMigracao: OrigemTransmissaoMigracao = origemTransmissao as OrigemTransmissaoMigracao;
                    origemTransmissaoMigracao.numeroEvento = indexEvt + 1;
                    this.dadosOrigem.push(origemTransmissaoMigracao);

                });
                this.ftaOrigem.eventos[indexEvt].detalheEventoTransmissao = evento.detalheEventoTransmissao;
                this.ftaOrigem.eventos[indexEvt].detalheEventoTransmissao.origem = this.origem;

                //ajusta destino
                this.destino = [];
                evento.detalheEventoTransmissao.destino.forEach(destinoTransmissao => {
                    destinoTransmissao.codInstalacaoProdutoDestino = null;
                    destinoTransmissao.vrsInstalacaoProdutoDestino = null;
                    if (destinoTransmissao.clienteDestino.codTipoCliente == 1) {
                        destinoTransmissao.clienteDestino.userAplicacao.codUserAplicacao = null;
                    }
                    this.destino.push(destinoTransmissao);
                    let destinoTransmissaoMigracao: DestinoTransmissaoMigracao = destinoTransmissao as DestinoTransmissaoMigracao;
                    destinoTransmissaoMigracao.numeroEvento = indexEvt + 1;
                    this.dadosDestino.push(destinoTransmissaoMigracao);
                });
                this.ftaOrigem.eventos[indexEvt].detalheEventoTransmissao.destino = this.destino;

            }

            //trata operacoes
            if (evento.detalheEventoOperacao != null) {
                let eventoOperacaoAux = evento.detalheEventoOperacao;
                eventoOperacaoAux.codOperacao = null;
                eventoOperacaoAux.vrsOperacao = null;
                delete eventoOperacaoAux.codLayout;
                delete eventoOperacaoAux.vrsLayout;
                delete eventoOperacaoAux.nomeLayout;
                this.ftaOrigem.eventos[indexEvt].detalheEventoOperacao = eventoOperacaoAux;
                this.dadosOperacao.push(eventoOperacaoAux);
            }


            //ajusta servicos para migracao
            let servicosVinculadosAux = new Array<ServicoVinculado>();
            evento.servicosVinculados.forEach(element => {
                element.codigo = null;
                element.versao = null;
                servicosVinculadosAux.push(element);
                this.dadosServico.push(element);
            });
            evento.servicosVinculados = servicosVinculadosAux;


        });

        this.verificarCompatiblidade();

    }

    errorHandler(erro: any): void {
        this.modalService.exibirMensagem('Atenção!', 'Erro ao salvar o FTA.', 'Fechar');
        this.globalService.loading = false;
    }

    verificarCompatiblidade() {

        this.buscarClientes('origem').concatMap(resp => {

            //popula clientes origem do outro ambiente
            if (resp != null) {

                this.dadosOrigem.forEach(cliente => {
                    resp.forEach(arrayCLiente => {
                        arrayCLiente.forEach(clienteResp => {
                            let trmOrigem: OrigemTransmissaoMigracao = new OrigemTransmissaoMigracao();
                            if (clienteResp.codTipoCliente == 1 && cliente.clienteOrigem.codTipoCliente == 1) {
                                if (clienteResp.userAplicacao.nomeUserAplicacao == cliente.clienteOrigem.userAplicacao.nomeUserAplicacao) {
                                    trmOrigem.clienteOrigem = clienteResp;
                                    this.dadosMigracaoOrigem.push(trmOrigem);
                                }
                            } else if (clienteResp.codTipoCliente == 2 && cliente.clienteOrigem.codTipoCliente == 2) {
                                if (clienteResp.mci.codMci == cliente.clienteOrigem.mci.codMci) {
                                    trmOrigem.clienteOrigem = clienteResp;
                                    this.dadosMigracaoOrigem.push(trmOrigem);
                                }
                            } else if (clienteResp.codTipoCliente == 3 && cliente.clienteOrigem.codTipoCliente == 3) {
                                if (clienteResp.uor.codUor == cliente.clienteOrigem.uor.codUor) {
                                    trmOrigem.clienteOrigem = clienteResp;
                                    this.dadosMigracaoOrigem.push(trmOrigem);
                                }
                            }
                        });
                    });
                });
            }
            return this.buscarInstalacoes('origem');
        })

            .concatMap(resp => {
                if (resp != null) {
                }
                return this.buscarClientes('destino');
            })

            .concatMap(resp => {
                if (resp != null) {
                }
                return this.buscarInstalacoes('destino');
            })

            .catch(
                (e: any) => Observable.throw(this.errorHandler(e))
            )

            .concatMap(resp => {

                //popula clientes destino do outro ambiente
                if (resp != null) {
                }

                return this.buscarServicos(this.dadosServico);

            }).subscribe(
            //popula servicos compativeis
            resp => {
                if (resp != null) {
                }
            },
            erro => {
            });
    }


    getTipoCliente(cliente: Cliente) {
        switch (cliente.codTipoCliente) {
            case 1:
                return 'Usuário Impessoal';
            case 2:
                return 'MCI';
            case 3:
                return 'UOR';
        }
    }

    getNomeCliente(cliente: Cliente) {
        switch (cliente.codTipoCliente) {
            case 1:
                return cliente.userAplicacao.nomeUserAplicacao;
            case 2:
                return cliente.mci.nomeCliente == null ? cliente.mci.codMci : cliente.mci.codMci + ' - ' + cliente.mci.nomeCliente;
            case 3:
                return cliente.uor.nomeDependencia == null ? cliente.uor.codUor : cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia;
            default:
                return 'Não foi possível recuperar o nome do cliente';
        }
    }

    getNomeAmbiente() {
        switch (this.campoAmbiente.value) {
            case 'DES':
                return 'Desenvolvimento';
            case 'HMG':
                return 'Homologação';
            case 'PRD':
                return 'Produção';
        }
    }

    migrarFTA() {

        if (this.ftaOrigem != null && this.tokenDestino != null && this.isAutenticadoNoDestino && this.migracaoModalForm.valid) {

            this.catalogoApi.migrarFta(0, 0, this.ftaOrigem, this.campoAmbiente.value, this.tokenDestino)
                .subscribe(
                    resposta => {
                        let msgSucesso = `FTA nº ${resposta.codigoCriado} v.${resposta.versaoCriada} gravado com sucesso no ambiente de ${this.getNomeAmbiente()}. <br>Estado: 'aguardando despacho'.`;
                        this.globalService.loading = false;

                        this.modalService.incluirDadosGerados({codigo: 200, mensagem: msgSucesso});
                        // this.modalService.fecharPaginaModal();

                    }
                    , erro => {
                        this.globalService.loading = false;
                        let msgErro = `Ocorreu um erro ao gravar o FTA.`;
                        this.modalService.incluirDadosGerados({codigo: 500, mensagem: msgErro});
                        // this.modalService.fecharPaginaModal();
                    }
                );
        }
    }

}

export function ValidaCampoAmbiente(control: AbstractControl) {
    let formulario = <FormGroup>control.parent;
    if (formulario != undefined && control.value == '0') {
        return {ValidaCampoAmbiente: true};
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/app/modal/migracao-fta-modal/migracao-fta-modal.component.ts